export interface PendingGridActionFocus {
  actionIndex: number;
  colId: string;
  expiresAt: number;
  gridFocusKey?: string;
  gridDomIndex: number;
  rowIdentity: Record<string, unknown>;
  rowIndex: number;
}

export class GridActionFocusRestore {
  private static pendingFocus: PendingGridActionFocus | null = null;

  public static clear(): void {
    GridActionFocusRestore.pendingFocus = null;
  }

  public static get(): PendingGridActionFocus | null {
    if (!GridActionFocusRestore.pendingFocus) {
      return null;
    }

    if (Date.now() > GridActionFocusRestore.pendingFocus.expiresAt) {
      GridActionFocusRestore.pendingFocus = null;
      return null;
    }

    return GridActionFocusRestore.pendingFocus;
  }

  public static hasOpenOverlay(): boolean {
    return !!document.querySelector('ion-popover, ion-modal, ion-alert, ion-action-sheet');
  }

  public static set(pendingFocus: PendingGridActionFocus): void {
    GridActionFocusRestore.pendingFocus = pendingFocus;
  }
}